module.exports = __webpack_public_path__ + "inner-banner.46cfd6c2b64c54d83f66.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/inner-banner.jpg
// module id = ../../../../../src/assets/img/inner-banner.jpg
// module chunks = styles